import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import i18n from 'i18next';
import { isMobile } from 'react-device-detect';
import HistoryIcon from '@material-ui/icons/History';
import Button from 'Mui/Button';
import { addOutlineBtnHoverStyle } from 'styles/common';
import PopupWithFixHeader, { modes } from 'client/components/PopupWithFixHeader';
import {
    stylePropType,
    btnPropType,
    childrenPropType,
    componentStylePropTypes
} from 'utils/propTypes';

function ViewRecordsBtn({
    componentStyle = {},
    style,
    btnStyle,
    variant = 'medium',
    children,
    onClick = () => {}
}) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const disabledPopup = !children;

    function showPrizeList() {
        if (!disabledPopup) {
            setIsPopupOpen(true);
        }
        onClick();
    }
    function closePrizeList() {
        setIsPopupOpen(false);
    }

    const smallerHistoryButton = (
        <Button css={[circleButtonStyle, css(btnStyle)]} color="primary" onClick={showPrizeList}>
            <HistoryIcon style={{ fontSize: 24, color: 'inherit' }} />
        </Button>
    );

    const mediumHistoryButton = (
        <Button
            css={[
                buttonStyle,
                css(`border-radius: ${componentStyle.contentBorderRadius};`),
                css(addOutlineBtnHoverStyle(componentStyle.descColor)),
                css(btnStyle)
            ]}
            variant="outlined"
            color="primary"
            onClick={showPrizeList}
        >
                {i18n.t('btn.join_record')}
        </Button>
    );

    return (
        <div css={[btnContainerStyle, css(style)]}>
            {variant === 'small' && smallerHistoryButton}
            {variant === 'medium' && mediumHistoryButton}
            {!disabledPopup && (
                <PopupWithFixHeader
                    show={isPopupOpen}
                    title={i18n.t('btn.join_record')}
                    onClose={closePrizeList}
                    mode={isMobile ? modes.COMP : modes.GLOBAL}
                >
                    {children}
                </PopupWithFixHeader>
            )}
        </div>
    );
}

export default ViewRecordsBtn;

ViewRecordsBtn.propTypes = {
    componentStyle: componentStylePropTypes,
    style: stylePropType,
    btnStyle: btnPropType,
    variant: PropTypes.oneOf(['small', 'medium', 'large']),
    children: childrenPropType,
    onClick: PropTypes.func
};

const btnContainerStyle = css`
    text-align: center;
`;

const buttonStyle = css`
    padding: 10px 16px;
    width: 100%;
    height: 48px;
    border-radius: 28px;
`;

const circleButtonStyle = css`
    padding: 0;
    min-width: 48px;
    width: 48px;
    height: 48px;
    border-radius: 50%;
`;